<template>
  <div>
    <v-form
      ref="formRepondants"
      v-model="formValid"
    >
      <v-row class="mt-5 mb-5">
        <v-col
          cols="12"
        >
          <label style="font-weight: bold">{{
            $t("Panier.SectionIdentificationRepondants.TitreSectionRepondants")
          }}</label>
        </v-col>

        <template v-for="(type, index) in ['repondantPere', 'repondantMere', 'repondantTuteur']">
          <v-row :key="index" class="ma-0" :class="appStore.estMobile ? 'mb-5' : ''">
            <v-col
              cols="12"
              sm="6"
              md="3"
              class="py-1 pr-1"
            >
              <v-text-field
                v-model="repondants[type].nom"
                v-on:input="validerRepondant()"
                :rules="[rules.requiredIfFilled(type)]"
                :label="$t(`Panier.SectionIdentificationRepondants.Nom${capitalize(type)}`)"
                outlined
                dense
                hide-details="auto"
              >
              </v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="3"
              class="py-1 pr-1"
            >
              <v-text-field
                v-model="repondants[type].prenom"
                v-on:input="validerRepondant()"
                :rules="[rules.requiredIfFilled(type)]"
                :label="$t(`Panier.SectionIdentificationRepondants.Prenom${capitalize(type)}`)"
                outlined
                dense
                hide-details="auto"
              >
              </v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="3"
              class="py-1 pr-1"
            >
              <v-text-field
                v-model="repondants[type].telephone"
                v-mask="'(###) ###-####'"
                v-on:input="validerRepondant()"
                :rules="[rules.telephone, rules.requiredIfFilled(type)]"
                :label="$t('Panier.SectionIdentificationRepondants.Telephone')"
                :placeholder="$t('Panier.SectionIdentificationRepondants.PlaceHolderTelephone')"
                outlined
                dense
                hide-details="auto"
              >
              </v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="3"
              class="py-1 pr-1"
            >
              <v-text-field
                v-model="repondants[type].courriel"
                v-on:input="validerRepondant()"
                :rules="[rules.courriel, rules.requiredIfFilled(type)]"
                :label="$t('Panier.SectionIdentificationRepondants.Courriel')"
                outlined
                dense
                hide-details="auto"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </template>
      </v-row>

      <div
        v-if="erreurMinimumRepondants"
        class="v-text-field__details"
      >
        <div
          class="v-messages theme--light error--text"
          role="alert"
        >
          <div class="v-messages__wrapper text-end">
            <div class="v-messages__message message-transition-enter-to">
              {{ $t("erreurs.MinimumRepondantsErreur") }}
            </div>
          </div>
        </div>
      </div>
    </v-form>
  </div>
</template>

<script>
import useAppStore from '@/store/appStore';

export default {
  name: 'IdentificationRepondants',
  props: {
    value: Object,
  },

  setup() {
    const appStore = useAppStore();
    return { appStore };
  },
  created() {
    this.repondants = this.value;
  },
  data() {
    return {
      repondants: Object,
      erreurMinimumRepondants: false,
      formValid: false,
      rules: {
        courriel: (value) => !value || /.+@.+\..+/.test(value) || this.$tc('erreurs.CourrielInvalide'),
        telephone: (value) => !value || /^\(\d{3}\) \d{3}-\d{4}$/.test(value) || this.$tc('erreurs.TelephoneInvalide'),
        requiredIfFilled: (type) => (value) => {
          const champs = this.repondants[type];
          const siUnChampsRempli =
            champs.nom !== '' || champs.prenom !== '' || champs.telephone !== '' || champs.courriel !== '';

          return !siUnChampsRempli || (value !== '' && value !== null) || this.$t('erreurs.requis');
        },
      },
    };
  },
  methods: {
    validerRepondant() {
      this.erreurMinimumRepondants =
        this.champsVides(this.repondants.repondantPere) &&
        this.champsVides(this.repondants.repondantMere) &&
        this.champsVides(this.repondants.repondantTuteur);

      if (this.$refs.formRepondants) {
        this.$refs.formRepondants.validate();
      }

      this.$emit('input', this.repondants);
    },
    champsVides(repondant) {
      return !repondant.nom.trim() &&
        !repondant.prenom.trim() &&
        !repondant.telephone.trim() &&
        !repondant.courriel.trim();
    },

    capitalize(type) {
      return type.charAt(0).toUpperCase() + type.slice(1);
    },
  },
};
</script>
<style scoped></style>
